import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { groupNameValidator } from '#validation';
export const groupUpdateSchema = z.object({
    name: groupNameValidator.optional(),
});
export class GroupUpdateDto extends createZodDto(groupUpdateSchema) {
}
